export default "__VITE_ASSET__BDkwP8Ic__"